import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: "gem2020-2017.firebaseapp.com",
  databaseURL: "https://gem2020-2017-default-rtdb.firebaseio.com",
  projectId: "gem2020-2017",
  storageBucket: "gem2020-2017.appspot.com",
  messagingSenderId: "314692192564",
  appId: "1:314692192564:web:20c14c0221f3f689b87d61",
  measurementId: "G-H880SR7CE7"
});

const db = firebaseApp.firestore();

export default db;